import { useQuery } from 'react-query';

import { QueryEntity } from '../types';
import { APIBaseChronos } from '@/api/hosts';
import useGetFetchConfig from '@/api/useGetFetchConfig';

export interface MatterOverviewResponse {
  totalFacts: number;
  documents: number;
  entities: number;
  disputedFacts: number;
  pages: number;
  chronologies: number;
}

export const useGetMatterOverview = (matterId: string | null = '') => {
  const { fetchConfigGET } = useGetFetchConfig();

  const getMatterOverview = async (): Promise<MatterOverviewResponse> => {
    const response = await fetch(`${APIBaseChronos}/api/matters/${matterId}/overview`, fetchConfigGET);
    if (!response.ok) {
      throw new Error('Fetching matter overview failed');
    }

    return response.json();
  };

  return useQuery([QueryEntity.MatterOverview, matterId], getMatterOverview, {
    refetchOnWindowFocus: false,
    enabled: !!matterId,
  });
};

export default useGetMatterOverview;
